import { NotificationService } from 'src/app/shared/services/notification.service';
import { inject, Component, EventEmitter, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {
  UploadFile,
  UploadInput,
  UploadOutput,
  UploadStatus
} from '../../../_models/primeng-uploads';
import { Subscription } from 'rxjs';
import { Application } from 'src/app/_models';
import { environment } from 'src/environments/environment';
import { UserRole } from '../../follow-ups/models/deviation';
import { BusinessEdit } from '../models';
import { BusinessServices } from '../services/business.services';

import { UploaderConfig } from './../../../shared/ecpl-document-explorer/uploader-config';
import { CacheHandlerService } from './../../cached.services';
import { BaseServices } from './../../kuba.services';
import { BusinessAgreement } from './../models/businessList';
import { DateService } from 'src/app/_services/date.service';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { DatePickerOptions } from 'src/app/_helpers/date-setting';
import { finalize } from 'rxjs/operators';
import { AppErrorCode } from 'src/app/_models/app-error-code.enum';

@Component({
  selector: 'business-license',
  templateUrl: 'business-license.component.html',
  styleUrls: ['business-license.component.css'],
  standalone: false
})
export class BusinessLicenseComponent implements OnInit {
  goToUserList(): void {
    this.showDowngradeBlocked = false;
    const businessId = this.agreement?.BusinessId ?? this.businessId;
    this.router.navigate(['/app/business', businessId, 'user/list']);
  }

  //#region variables

  private readonly notifications = inject(NotificationService);
  licenseagrmtForm: FormGroup;
  agreement: BusinessAgreement;
  upConfig: UploaderConfig;
  isLinkHide = true;
  businessId = 0;
  isHide = true;
  isSubmitting = false;
  fileName: string;
  licenseMonths: any;
  editAgreement: any;
  document = '';
  agreementName: string;
  isFileChoosed = false;
  files: UploadFile[] = [];
  licenseAgreementDocument: any;
  uploadInput: EventEmitter<UploadInput>;
  dragOver: boolean;
  businessInfo: any;
  remoteWindow: Window;
  selDate: any;
  isAdmin: boolean;
  roleId: number;
  licenseCategory: any = [];
  licenseCategoryList: any;
  isDinHMSLogin = false;
  hasLicenseCategory = false;
  businessEdit: BusinessEdit;
  isDinHMS = false;
  usersCount: number;
  employeesCount: number;
  showDowngradeBlocked = false;
  downgradeEmployeesToRemove = 0;
  private subscriptions: Subscription[] = [];
  public isDatePickerDisabled = false;
  public PurchaseDateOptions: DatePickerOptions = {
    dateFormat: 'dd/mm/yyyy',
    editableDateField: false,
    openSelectorOnInputClick: true,
    firstDayOfWeek: 'su',
    satHighlight: true,
    height: '26px',
    selectionTxtFontSize: '14px',
    todayBtnTxt: this.translate.instant('TODAY'),
    dayLabels: {
      su: this.translate.instant('SUN'),
      mo: this.translate.instant('MON'),
      tu: this.translate.instant('TUE'),
      we: this.translate.instant('WED'),
      th: this.translate.instant('THU'),
      fr: this.translate.instant('FRI'),
      sa: this.translate.instant('SAT')
    },
    monthLabels: {
      1: this.translate.instant('JANUARY'),
      2: this.translate.instant('FEBRUARY'),
      3: this.translate.instant('MARCH'),
      4: this.translate.instant('APRIL'),
      5: this.translate.instant('MAY'),
      6: this.translate.instant('JUNE'),
      7: this.translate.instant('JULY'),
      8: this.translate.instant('AUGUST'),
      9: this.translate.instant('SEPTEMBER'),
      10: this.translate.instant('OCTOBER'),
      11: this.translate.instant('NOVEMBER'),
      12: this.translate.instant('DECEMBER')
    }
  };
  public ExpiryDateOptions: DatePickerOptions = this.PurchaseDateOptions;
  isMedi3: boolean = false;
  //#endregion
  //#region constructor
  /**
   * constructor
   * @param formBuilder {FormBuilder}
   * @param businessagrremnt {BusinessServices}
   * @param route {ActivatedRoute}
   */
  constructor(
    private formBuilder: FormBuilder,
    private businessagrremnt: BusinessServices,
    private route: ActivatedRoute,
    private businessServices: BusinessServices,
    private cacheHandlerService: CacheHandlerService,
    private translate: TranslateService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private dateService: DateService,
    private authenticationService: AuthenticationService
  ) {
    this.businessId = this.route.snapshot.parent?.params['bid'];
    this.businessInfo = this.route.snapshot.data['list'];
  }
  //#endregion
  //#region page-events
  /**
   * bind AgreementName based on ApplicationId,bind license agreement dropdown,edit license agreement
   */
  ngOnInit() {
    document.querySelector('body').classList.remove('opened');
    if (
      BaseServices.ApplicationId === Application.DIN_HMS ||
      BaseServices.ApplicationId === Application.IK ||
      BaseServices.ApplicationId === 4
    ) {
      // #KW-176
      this.isDinHMSLogin = true;
      this.isDinHMS = true;
      this.businessEdit = new BusinessEdit();
      this.businessEdit = JSON.parse(localStorage.getItem('detailsInfo')!);
    }
    // Applications whose license agreement is described by a license category
    // instead of a free-text agreement name. AGIL, UNIPRO and SALUTIS were left
    // on the free-text field, which onSubmitTemplateBased discards on save, so
    // their admins had no way to set a category at all.
    this.hasLicenseCategory =
      this.isDinHMSLogin ||
      BaseServices.ApplicationId === Application.UNIPRO ||
      BaseServices.ApplicationId === Application.AGIL ||
      BaseServices.ApplicationId === Application.SALUTIS;
    if (BaseServices.ApplicationId == 5) {
      this.isMedi3 = true;
    }
    this.licenseCategory = this.route.snapshot.data['licenseCategoryList'];
    this.isAdmin =
      +BaseServices.roleId === UserRole.ADMIN ||
      +BaseServices.roleId === UserRole.PORTAL
        ? true
        : false;
    this.uploadInput = new EventEmitter<UploadInput>();
    switch (BaseServices.UserRole.toUpperCase()) {
      case 'ADMIN':
        this.isHide = false;
        this.isLinkHide = true;
        this.isDatePickerDisabled = false;
        break;
      case 'EDITOR':
        this.isHide = true;
        this.isLinkHide = false;
        this.isDatePickerDisabled = true;
        break;
      case 'USER':
        this.isHide = false;
        this.isLinkHide = true;
        this.isDatePickerDisabled = false;
        break;
      case 'GUEST':
        this.isHide = false;
        this.isLinkHide = true;
        this.isDatePickerDisabled = false;
        break;
      case 'PORTAL':
        this.isHide = false;
        this.isLinkHide = true;
        this.isDatePickerDisabled = false;
        break;
    }
    switch (BaseServices.ApplicationId) {
      case 1:
        this.agreementName = 'Kuba';
        break;
      case 2:
        this.agreementName = 'Kuba';
        break;
      case 3:
        this.agreementName = 'Kuba';
        break;
      case 4:
        this.agreementName = 'Kuba';
        break;
    }
    this.roleId = +BaseServices.roleId;
    if (this.route.snapshot.parent?.url[0].path === 'new') {
      this.businessEdit = new BusinessEdit();
      this.businessEdit = JSON.parse(localStorage.getItem('detailsInfo')!);
    } else {
      this.agreement = this.route.snapshot.data['agreement'];
      this.usersCount = this.route.snapshot.data['usersCount'];
      this.employeesCount = this.route.snapshot.data['employeesCount'];
    }
    this.licenseagrmtForm = this.formBuilder.group({
      ExpiryDate: new FormControl<Date | null>(null),
      PurchaseDate: new FormControl<Date | null>(null, Validators.required),
      Description: [''],
      AgreementName: [''],
      SalesPerson: [],
      LicenseMonth: [],
      LicenseCategory: new FormControl<number | null>(
        null,
        Validators.required
      ),
      PricePerMonth: [0, Validators.required],
      NoOfEmployees: [this.employeesCount],
      NoOfUsers: [this.usersCount],
      EmployeeLimit: [null],
      UnlimitedEmployees: [true]
    });

    if (BaseServices.ApplicationId == 4) {
      this.licenseagrmtForm.controls['LicenseCategory'].setValue(6);
    }

    this.licenseCategoryList = [];

    this.translate.stream('SELECT_LICENSE_CATEGORY').subscribe(val => {
      this.licenseCategoryList = [];
      this.licenseCategoryList.push({
        label: this.translate.instant('SELECT'),
        value: null
      });
      this.licenseCategory.forEach((element: any) => {
        if (element) {
          if (
            BaseServices.ApplicationId == 4 || BaseServices.ApplicationId == 2
              ? element.Id != 5
              : element.Id
          ) {
            this.licenseCategoryList.push({
              label: this.translate.instant(element.TranslateKey),
              value: element.Id
            });
          }
        }
      });
    });

    /**
     * bind license months dropdown
     */
    this.subscriptions.push(
      this.translate.stream('SELECT_MONTH').subscribe(val => {
        this.licenseMonths = [];
        this.licenseMonths.push(
          { label: val.SELECT, value: '00' },
          { label: val.JANUARY, value: '01' },
          { label: val.FEBRUARY, value: '02' },
          { label: val.MARCH, value: '03' },
          { label: val.APRIL, value: '04' },
          { label: val.MAY, value: '05' },
          { label: val.JUNE, value: '06' },
          { label: val.JULY, value: '07' },
          { label: val.AUGUST, value: '08' },
          { label: val.SEPTEMBER, value: '09' },
          { label: val.OCTOBER, value: '10' },
          { label: val.NOVEMBER, value: '11' },
          { label: val.DECEMBER, value: '12' }
        );
      })
    );
    /**
     * edit agreement
     */
    if (this.agreement) {
      const purchaseDate = new Date(this.agreement.PurchaseDate);

      let expiryDate: any;
      if (this.agreement.ExpiryDate) {
        expiryDate = new Date(this.agreement.ExpiryDate);
      }

      this.editAgreement = {
        ExpiryDate: expiryDate ? expiryDate : '',
        PurchaseDate: purchaseDate ? purchaseDate : '',
        Description: this.agreement.Description,
        SalesPerson: this.agreement.SalesPerson,
        LicenseMonth: this.agreement.LicenseMonth,
        AgreementName: this.agreement.AgreementName || this.agreementName || '',
        LicenseCategory: this.agreement.LicenseCategoryId,
        PricePerMonth: this.agreement.PricePerMonth,
        NoOfEmployees: this.employeesCount,
        NoOfUsers: this.usersCount,
        EmployeeLimit: this.agreement.EmployeeLimit ?? null,
        UnlimitedEmployees:
          this.agreement.EmployeeLimit === null ||
          this.agreement.EmployeeLimit === undefined
      };
      (<FormGroup>this.licenseagrmtForm).setValue(this.editAgreement, {
        onlySelf: true
      });

      if (this.agreement.DocumentPath) {
        this.document = this.agreement.DocumentPath;
      }

      if (
        BaseServices.ApplicationId == 4 &&
        this.agreement.LicenseCategoryId == null
      ) {
        this.licenseagrmtForm.controls['LicenseCategory'].setValue(6);
      }
    }

    if (this.businessId > 0) {
      this.subscriptions.push(
        this.businessServices.getEmployeeLimit(this.businessId).subscribe(usage => {
          this.usersCount = usage.SeatsInUse;
          this.licenseagrmtForm.patchValue({ NoOfUsers: this.usersCount });
        })
      );
    }
  }

  /**
   * on upload event
   * @param output
   */
  onUploadOutput(output: UploadOutput): void {
    if (output.type === 'allAddedToQueue') {
      // uncomment this if you want to auto upload files when added
      let crfToken = this.authenticationService.getCsrfToken();
      const event: UploadInput = {
        type: 'uploadAll',
        url: environment.BASE_URL + '/file/upload/business/licenseagreement',
        method: 'POST',
        headers: {
          'Logo-Id': 'ab064fd4-9b4a-4e70-972d-dafdaceb2aba',
          'X-XSRF-TOKEN': crfToken
        },
        data: {
          ApplicationId: `${BaseServices.ApplicationId}`,
          BusinessId: `${this.businessId ? this.businessId : 0}`,
          ParentId: `${this.businessId ? this.businessId : 0}`,
          Status: '1',
          CreatedOn: `${new Date()}`,
          ModifiedBy: `${BaseServices.UserId}`,
          ModifiedOn: `${new Date()}`
        },
        withCredentials: true
      };
      this.uploadInput.emit(event);
    } else if (
      output.type === 'addedToQueue' &&
      typeof output.file !== 'undefined'
    ) {
      this.isFileChoosed = true;
      this.files.push(output.file);
    } else if (
      output.type === 'uploading' &&
      typeof output.file !== 'undefined'
    ) {
      const index = this.files.findIndex(
        file => typeof output.file !== 'undefined' && file.id === output.file.id
      );
      this.files[index] = output.file;
    } else if (output.type === 'removed') {
      this.files = this.files.filter(
        (file: UploadFile) => file !== output.file
      );
    } else if (output.type === 'dragOver') {
      this.dragOver = true;
    } else if (output.type === 'dragOut') {
      this.dragOver = false;
    } else if (output.type === 'drop') {
      this.dragOver = false;
    } else if (output.type === 'done') {
      this.licenseAgreementDocument = output.file?.response;
    } else if (
      output.type === 'rejected' &&
      typeof output.file !== 'undefined'
    ) {
    }

    this.files = this.files.filter(
      file => file.progress.status !== UploadStatus.Done
    );
    this.fileName = this.files ? this.files[0].name : '';
  }

  onSaveBusinessDetails(isNavigate: any) {
    if (this.businessEdit && this.isDinHMS) {
      this.isSubmitting = true;
      this.businessEdit.CreatedOn = new Date();
      if (this.businessEdit.Id === 0) {
        this.subscriptions.push(
          this.businessServices
            .create(this.businessEdit)
            .pipe(
              finalize(() => {
                this.isSubmitting = false;
              })
            )
            .subscribe((result: any) => {
              if (result) {
                this.businessId = result.Id;
                this.businessEdit.Id = result.Id;
                this.businessEdit.ModifiedBy = BaseServices.UserId;
                localStorage.setItem(
                  'detailsInfo',
                  JSON.stringify(this.businessEdit)
                );
                this.onSubmitTemplateBased(isNavigate);
              }
            })
        );
      } else {
        this.businessEdit.ModifiedBy = BaseServices.UserId;
        this.subscriptions.push(
          this.businessServices
            .update(this.businessId, this.businessEdit)
            .pipe(
              finalize(() => {
                this.isSubmitting = false;
              })
            )
            .subscribe(result => {
              if (result) {
                this.onSubmitTemplateBased(isNavigate);
              }
            })
        );
      }
    } else {
      this.onSubmitTemplateBased(isNavigate);
    }
  }

  onSubmitTemplateBased(isNavigate: any) {
    if (this.businessEdit || +this.businessId !== 0) {
      let bId = this.businessEdit ? this.businessEdit.Id : +this.businessId;
      if (bId !== 0) {
        this.businessServices
          .getAgreementByBusinessId(bId)
          .subscribe((result: any) => {
            if (result) {
              this.agreement = result;
            }

            let businessAgreement = this.agreement
              ? this.agreement
              : new BusinessAgreement();
            businessAgreement.LicenseCategoryId =
              this.licenseagrmtForm.value.LicenseCategory;
            businessAgreement.PricePerMonth =
              this.licenseagrmtForm.value.LicenseCategory === 1
                ? null
                : this.licenseagrmtForm.value.PricePerMonth;
            businessAgreement.Description =
              this.licenseagrmtForm.value.Description;
            businessAgreement.SalesPerson =
              this.licenseagrmtForm.value.SalesPerson;

            businessAgreement.PurchaseDate = this.licenseagrmtForm.value
              .PurchaseDate
              ? this.dateService.formatDateToString(
                  this.licenseagrmtForm.value.PurchaseDate
                )
              : null!;

            businessAgreement.ExpiryDate = this.licenseagrmtForm.value
              .ExpiryDate
              ? this.dateService.formatDateToString(
                  this.licenseagrmtForm.value.ExpiryDate
                )
              : null!;

            businessAgreement.LicenseMonth =
              this.licenseagrmtForm.value.LicenseMonth;
            businessAgreement.AgreementName =
              this.licenseagrmtForm.value.AgreementName || this.agreementName;
            businessAgreement.NoOfEmployees = this.employeesCount;
            businessAgreement.NoOfUsers = this.usersCount;
            businessAgreement.IsUnlimitedEmployees =
              !!this.licenseagrmtForm.value.UnlimitedEmployees;
            businessAgreement.EmployeeLimit =
              businessAgreement.IsUnlimitedEmployees
                ? null
                : this.licenseagrmtForm.value.EmployeeLimit;
            if (this.agreement) {
              businessAgreement.Id = this.agreement.Id;
              businessAgreement.BusinessId = this.agreement.BusinessId;
              businessAgreement.DocumentPath = this.licenseAgreementDocument
                ? this.licenseAgreementDocument.path
                  ? this.licenseAgreementDocument.path
                  : this.document
                : this.document;
              this.subscriptions.push(
                this.businessagrremnt
                  .updateAgreement(businessAgreement)
                  .subscribe(updateResponse => {
                    if (updateResponse) {
                      this.notifications.success('UI_NOTIFICATIONS.SAVED');
                      if (this.isDinHMS && isNavigate) {
                        if (this.route.snapshot.parent?.url[0].path === 'new') {
                          this.router.navigate(
                            [`./../../edit/${this.businessId}/features`],
                            { relativeTo: this.route }
                          );
                        } else {
                          this.router.navigate([`../features`], {
                            relativeTo: this.route
                          });
                        }
                      }
                    }
                  },
                    (error: any) => {
                      if (
                        error?.error?.Code ===
                        AppErrorCode.EmployeeLimitBelowActiveEmployees
                      ) {
                        this.downgradeEmployeesToRemove = Math.max(
                          0, this.usersCount - (this.licenseagrmtForm.value.EmployeeLimit ?? 0)
                        );
                        this.showDowngradeBlocked = true;
                      } else {
                        this.notifications.error('UI_NOTIFICATIONS.TRY_AGAIN');
                      }
                    }
                  )
              );
            } else {
              businessAgreement.ApplicationId = BaseServices.ApplicationId;
              businessAgreement.BusinessId = this.businessId;
              businessAgreement.Status = '1';
              businessAgreement.DocumentPath = this.licenseAgreementDocument
                ? this.licenseAgreementDocument.path
                  ? this.licenseAgreementDocument.path
                  : this.document
                : this.document;
              this.subscriptions.push(
                this.businessagrremnt
                  .add(businessAgreement)
                  .subscribe(addResponse => {
                    if (addResponse) {
                      this.notifications.success('UI_NOTIFICATIONS.SAVED');
                      if (this.isDinHMS && isNavigate) {
                        if (this.route.snapshot.parent?.url[0].path === 'new') {
                          this.router.navigate(
                            [`./../../edit/${this.businessId}/features`],
                            { relativeTo: this.route }
                          );
                        } else {
                          this.router.navigate([`../features`], {
                            relativeTo: this.route
                          });
                        }
                      }
                    }
                  })
              );
            }
          });
      }
    }
  }
  /***
   * clear fields
   */
  clear() {
    this.licenseagrmtForm = this.formBuilder.group({
      ExpiryDate: [],
      PurchaseDate: [''],
      Description: [''],
      AgreementName: [''],
      SalesPerson: [],
      LicenseMonth: [],
      LicenseCategory: [],
      PricePerMonth: [0],
      NoOfEmployees: [0],
      NoOfUsers: [0],
      EmployeeLimit: [null],
      UnlimitedEmployees: [true]
    });
    this.fileName = '';
    if (this.agreement) {
      this.agreement.DocumentPath = '';
    }
  }

  /**
   * edit status
   * @param Id {number}
   * @param Status {number}
   * @param endDate {string}
   */
  editBusinessStatus(Id: number, Status: string, endDate: any) {
    let currentDate = new Date();
    let date = currentDate.toString();
    let expiryDate = new Date(endDate.formatted);
    expiryDate.setHours(23);
    expiryDate.setMinutes(59);
    expiryDate.setSeconds(59);
    let eDate = expiryDate.toString();
    if (date === eDate) {
      {
        this.subscriptions.push(
          this.businessServices.statusUpdate(Id, Status).subscribe(() => {})
        );
      }
    }
  }
  //#endregion

  /**
   * remote mode event
   * @param event {any}
   * @param business {any}
   */
  rModeLicenceAgreement() {
    let business = this.businessInfo.filter(
      (x: any) => x.Id === +this.businessId
    );
    if (this.remoteWindow) {
      this.remoteWindow.close();
    }
    this.cacheHandlerService.clearCachedData();
    let businessSetting = {
      BusinessName: business[0].CompanyName,
      BusinessLogo: business[0].BusinessLogo,
      teat: 1
    };
    sessionStorage.setItem('RModeBusiness', JSON.stringify(businessSetting));
    sessionStorage.setItem('RModeBusinessId', business[0].Id);
    let windowOrigin = window.location.origin;
    let windowControl =
      'location=yes,width=' +
      screen.availWidth +
      ', height = ' +
      screen.availHeight +
      ', scrollbars = yes, status = yes';
    this.remoteWindow = window.open(
      windowOrigin + '/ik/app/business/' + business[0].Id + '/dashboard',
      'Remote',
      windowControl
    )!;
  }

  /**
   * Returns true when the save button must stay disabled.
   * Every application requires a purchase date. Applications that pick a
   * license category require one; only those that also show the price field
   * require a price. The rest require the free-text agreement name.
   */
  onCheckValidation() {
    if (!this.licenseagrmtForm) {
      return true;
    }

    const agreement = this.licenseagrmtForm.value;

    if (!agreement.UnlimitedEmployees &&
        (!Number.isSafeInteger(agreement.EmployeeLimit) || agreement.EmployeeLimit < 1)) {
      return true;
    }

    if (!agreement.PurchaseDate) {
      return true;
    }

    if (!this.hasLicenseCategory) {
      return !agreement.AgreementName;
    }

    if (!agreement.LicenseCategory) {
      return true;
    }

    return (
      this.isDinHMSLogin &&
      agreement.LicenseCategory !== 1 &&
      (agreement.PricePerMonth === null || agreement.PricePerMonth === '')
    );
  }

  onPriceChange(e: any, limitNumber: any) {
    const limit = limitNumber;
    let charCode = e.which ? e.which : e.keyCode;
    if (
      e.target.value.length === limit ||
      (charCode > 31 && (charCode < 48 || charCode > 57))
    ) {
      e.preventDefault();
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub, i) => {
      sub.unsubscribe();
    });
  }
  //#endregion
}
